/**
 * 
 * js du flexblie content bloc_seo_static_offre_webservice.php
 * 
 */

jQuery(function() {
    try {
        //Bloc "SEO"
        if (jQuery("#section-liste-offres-seo").length>0) {               
            Kinougarde.OffresEmploi.ActualiseDejaVuesPostule();
        };         
    }     
    catch (ex) {
        console.error(ex);
    }
});